import PropTypes from 'prop-types';

TextArea.propTypes = {
  labelText: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  currentValue: PropTypes.string,
  description: PropTypes.string,
};
export default function TextArea({
  labelText,
  placeholder = '',
  fieldName,
  onChange,
  className = '',
  currentValue = '',
  description = null,
}) {
  return (
    <fieldset className={`fieldset ${className}`}>
      <legend className="fieldset-legend -mb-0.5 pb-0">{labelText}</legend>
      <textarea
        className="textarea h-24 w-full"
        placeholder={placeholder}
        name={fieldName}
        onChange={onChange}
      >
        {currentValue}
      </textarea>
      {description && <div className="fieldset-label">{description}</div>}
    </fieldset>
  );
}
